import { MutationInputError } from 'providers/tanstack-query/types'

export const fixAttributeDuplicatePaths = (
  attribute: MutationInputError['attribute'],
): MutationInputError['attribute'] => attribute.split('.').slice(1).join('.')
